import React from 'reactn';
import {
    Select,
    Card,
    CardContent,
    withStyles,
    Switch,
    Box,
    Typography,
    FormControl,
    InputLabel,
    TextField,
    MenuItem,
    Tooltip
} from '@material-ui/core';

import { Accordion, Schedule, Loader } from '../../..';
import styles from '../index.style';
import { CustomCheckbox } from '../../../../custom-checkbox';

const Feeds = (props) => {
    const { classes, currentLocation, parentLocation, manageRelationships, messagingAttorney, autoCreateRelationships } = props;
    const tooltipText = `This feature isn't available at ${currentLocation} because it is turned off at ${parentLocation}.`
    let featureData = { classes: [classes.level1Box, props.isSuperAdmin ? "" : classes.noBorderBottom], tooltipText: '' }
    let manageRelationshipsData = { classes: [classes.level1Box], tooltipText: '' }
    let messagingAttorneyData = { classes: [classes.level1Box], tooltipText: '' }
    let autoCreateRelationshipsData = { classes: [classes.level1Box, classes.noBorderBottom], tooltipText: '' }
    if (props._cacheData && props.disableFeatureToggle(props._cacheData)) {
        featureData = { classes: [classes.level1Box, props.isSuperAdmin ? "" : classes.noBorderBottom, classes.disableFeature], tooltipText, disableSwitch: true }
    }
    if (manageRelationships._cacheData && props.disableFeatureToggle(manageRelationships._cacheData)) {
        manageRelationshipsData = { classes: [classes.level1Box, classes.disableFeature], tooltipText, disableSwitch: true }
    }
    if (messagingAttorney._cacheData && props.disableFeatureToggle(messagingAttorney._cacheData)) {
        messagingAttorneyData = { classes: [classes.level1Box, classes.disableFeature], tooltipText, disableSwitch: true }
    }
    if (autoCreateRelationships._cacheData && props.disableFeatureToggle(autoCreateRelationships._cacheData)) {
        autoCreateRelationshipsData = { classes: [classes.level1Box, classes.noBorderBottom, classes.disableFeature], tooltipText, disableSwitch: true }
    }
    return (
        <Accordion
            id="accordion"
            title="Feeds">
            <Card variant="outlined" className={classes.outlinedComponent}>
                <CardContent
                    classes={{
                        root: [classes.settingsRoot, classes.noPaddBottom].join(" ")
                    }}>
                    {/* BEGIN: ROW */}
                    <Box
                        component="div"
                        justifyContent="space-between"
                        className={featureData.classes.join(" ")}
                        display="flex"
                    >
                        <Box
                            component="div"
                            textAlign="left"
                        >
                            <Typography className={classes.boxHeading1}>
                                Feeds Access
                            </Typography>
                            <Typography className={classes.subHeading1}>
                                {/* FOR FACILITY */}
                                {props.type === 'facility' && "If turned off, learners will not have access to Staff Feeds in the Learner Portal."}
                                {props.type === 'learner' && "If turned off, this learner will not have access to Staff Feeds in the Learner Portal."}
                            </Typography>
                        </Box>
                        <Tooltip title={featureData.tooltipText}>
                            <Box
                                display="flex"
                                alignItems="center"
                                component="div">
                                {props.messagingStatusLoader && (<Loader />)}
                                <CustomCheckbox
                                    id="status-checkbox"
                                    onChange={() => {
                                        props.showWarningIfApplicable((!props.status), () => {
                                            props.updateSettingsState('feature', {
                                                status: !props.status
                                            }, 'features', 'messaging', 'messagingStatusLoader')
                                        })
                                    }}
                                    checked={props.status}
                                    disabled={featureData.disableSwitch}
                                />
                            </Box>
                        </Tooltip>
                    </Box>
                    {/* END: ROW */}
                    {
                        (props.isSuperAdmin || props.isFacilityAdmin) && props.type === 'facility' &&
                        <>
                            {/* BEGIN: ROW */}
                            <Box
                                component="div"
                                justifyContent="space-between"
                                className={autoCreateRelationshipsData.classes.join(" ")}
                                display="flex"
                            >
                                <Box
                                    component="div"
                                    textAlign="left"
                                >
                                    <Typography className={classes.boxHeading1}>
                                        Learners Can Create Conversations
                                    </Typography>
                                    <Typography className={classes.subHeading1}>
                                        {"Turning this on will allow learners to create conversations with admins at their facility."}
                                    </Typography>
                                </Box>
                                <Tooltip title={autoCreateRelationshipsData.tooltipText}>
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        component="div">
                                        {props.autoCreateRelationshipsLoader && (<Loader />)}
                                        <CustomCheckbox
                                            id="status-checkbox"
                                            onChange={() => {
                                                props.showWarningIfApplicable((!autoCreateRelationships.status), () => {
                                                    props.updateSettingsState('feature', {
                                                        status: !autoCreateRelationships.status
                                                    }, 'features', 'autoCreateRelationships', 'autoCreateRelationshipsLoader')
                                                })
                                            }}
                                            checked={autoCreateRelationships.status}
                                            disabled={autoCreateRelationshipsData.disableSwitch}
                                        />
                                    </Box>
                                </Tooltip>
                            </Box>
                            {/* END: ROW */}
                        </>
                    }
                </CardContent>
            </Card>
        </Accordion>
    );
};

export default withStyles(styles)(Feeds);